import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = {
    url: String,
    paramName: { type: String, default: "ordered_items" }
  }

  connect() {
    this.initDragAndDrop()
  }

  initDragAndDrop() {
    this.itemTargets.forEach(item => {
      item.setAttribute("draggable", "true")
      item.addEventListener("dragstart", this.dragStart.bind(this))
      item.addEventListener("dragover", this.dragOver.bind(this))
      item.addEventListener("drop", this.drop.bind(this))
      item.addEventListener("dragend", this.dragEnd.bind(this))
    })
  }

  dragStart(event) {
    this.draggedElement = event.currentTarget
    event.currentTarget.classList.add("opacity-50")
    event.dataTransfer.effectAllowed = "move"
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const target = event.currentTarget
    if (target === this.draggedElement) return

    const rect = target.getBoundingClientRect()
    const midY = rect.top + rect.height / 2

    if (event.clientY < midY) {
      target.parentNode.insertBefore(this.draggedElement, target)
    } else {
      target.parentNode.insertBefore(this.draggedElement, target.nextSibling)
    }
  }

  drop(event) {
    event.preventDefault()
  }

  dragEnd(event) {
    event.currentTarget.classList.remove("opacity-50")
    this.saveOrder()
  }

  saveOrder() {
    if (!this.urlValue) return

    const orderedItems = this.itemTargets.map(item => ({
      id: item.dataset.itemId,
      section_id: item.dataset.sectionId || null
    }))

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: JSON.stringify({ [this.paramNameValue]: orderedItems })
    })
  }
}
